import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './app.reducer';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  isDirectClient: boolean;
  constructor( private store: Store<AppState> ) {
    this.isDirectClient = localStorage.getItem('isDirectClient')==='1';
    console.log('isDirectClient ',this.isDirectClient);
  }

  ngOnInit(): void {
  }
}
